// Recovered compiled webpack factory 66048. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      FetchStrategy: function () {
        return h;
      },
      NavigationResultTag: function () {
        return d;
      },
      PrefetchPriority: function () {
        return p;
      },
      cancelPrefetchTask: function () {
        return l;
      },
      createCacheKey: function () {
        return f;
      },
      getCurrentCacheVersion: function () {
        return i;
      },
      isPrefetchTaskDirty: function () {
        return c;
      },
      navigate: function () {
        return a;
      },
      prefetch: function () {
        return n;
      },
      reschedulePrefetchTask: function () {
        return u;
      },
      revalidateEntireCache: function () {
        return o;
      },
      schedulePrefetchTask: function () {
        return s;
      },
    }));
  let r = () => {
      throw Object.defineProperty(
        Error("Segment Cache experiment is not enabled. This is a bug in Next.js."),
        "__NEXT_ERROR_CODE",
        { value: "E654", enumerable: !1, configurable: !0 },
      );
    },
    n = r,
    a = r,
    o = r,
    i = r,
    s = r,
    l = r,
    u = r,
    c = r,
    f = r;
  var d = (function (e) {
      return (
        (e[(e.MPA = 0)] = "MPA"),
        (e[(e.Success = 1)] = "Success"),
        (e[(e.NoOp = 2)] = "NoOp"),
        (e[(e.Async = 3)] = "Async"),
        e
      );
    })({}),
    p = (function (e) {
      return (
        (e[(e.Intent = 2)] = "Intent"),
        (e[(e.Default = 1)] = "Default"),
        (e[(e.Background = 0)] = "Background"),
        e
      );
    })({}),
    h = (function (e) {
      return (
        (e[(e.LoadingBoundary = 0)] = "LoadingBoundary"),
        (e[(e.PPR = 1)] = "PPR"),
        (e[(e.PPRRuntime = 2)] = "PPRRuntime"),
        (e[(e.Full = 3)] = "Full"),
        e
      );
    })({});
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
